import React from 'react'

import { Button } from '@/components/Buttons'
import { MapPageContent } from '@/components/cms/__MapPageContent'
import { GridContainer } from '@/components/Grid'
import Layout from '@/components/Layout'
import { ResponsiveSpacer } from '@/components/Spacing'
import { CareersPageProps } from '@/interfaces/index'
import { fetchContent } from '@/utils/contentful/fetch-content'
import { ContentfulCareersQuery } from '@/utils/contentful/gql'

const CareersPage = ({ cmsData }: CareersPageProps) => {
  return (
    <Layout
      title={`Shift Lab is now hiring ${cmsData.displayTitle}s everywhere.`}
      url={`/careers/${cmsData.slug}`}
      description={`Born and based in NYC, we are now hiring ${cmsData.displayTitle}s everywhere. Come join our well-rounded, dynamic team known for premium, innovative product design and development work.`}
      imageCTA={`Join us! Learn more about our ${cmsData.displayTitle} role.`}
    >
      <>
        <MapPageContent pageContent={cmsData.pageContentCollection.items} />

        <ResponsiveSpacer size="md" />

        <section>
          <GridContainer>
            <div className="col-span-full">
              <Button>
                <a
                  className="__shift-lab-button-link"
                  href={cmsData.applyLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>Apply yourself</span>
                </a>
              </Button>
            </div>
          </GridContainer>
        </section>
        <ResponsiveSpacer size="xl" />
      </>
    </Layout>
  )
}

export async function getStaticPaths(): Promise<any> {
  const data = await fetchContent(`
    {
     	careersCollection(limit: 2500) {
        items {
          slug
        }
      }
    }
  `)

  const paths = data?.careersCollection.items.map((slugFromCms: any) => {
    return {
      params: { slug: slugFromCms.slug },
    }
  })

  return {
    paths,
    fallback: false,
  }
}

export async function getStaticProps({ params }: any) {
  const data = await fetchContent(`{
    careersCollection(where: { slug: "${params.slug}" }, limit: 1) {
      items {
        ${ContentfulCareersQuery}
      }
    }
  }`)

  return {
    props: {
      cmsData: data.careersCollection.items[0],
    },
  }
}

export default CareersPage
